import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import styles from '../Dialog.module.sass'
import { mapNonSurgicalAdmissionDetails } from 'controllers/TaskManager/TaskSubControllers/TaskDetailsControllers/detailsUtils'
import InfoList from 'components/InfoList/InfoList'
import TaskMedicalActsController from 'controllers/TaskManager/TaskSubControllers/TaskMedicalActsController/TaskMedicalActsController'
import { TaskForwardingController } from 'controllers/TaskManager/TaskSubControllers/TaskForwardingController/TaskForwardingController'
import TaskPaymentsController from 'controllers/TaskManager/TaskSubControllers/TaskPaymentsController/TaskPaymentsController'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import HFTextInput from 'components/HFInputs/HFTextInput'
import { TaskNeedsController } from 'controllers/TaskManager/TaskSubControllers/TaskNeedsController/TaskNeedsController'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'

export const NonSurgicalAdmissionAdministrativeForm = (props) => {
	const { i18n } = useGlobal()
	const { data } = props
	const {
		requisition,
		outsideNetwork,
		districts,
		serviceProviders,
		isFromIsland,
	} = data

	const requisitionDetails = mapNonSurgicalAdmissionDetails(requisition, i18n)

	return (
		<>
			<fieldset>
				<VStack>
					<h4>{i18n`Non surgical admission data`}</h4>
					<InfoList
						items={requisitionDetails}
						orientation={'vertical'}
					/>
				</VStack>
			</fieldset>

			<fieldset>
				<TaskMedicalActsController requisition={requisition} />
			</fieldset>

			<TaskForwardingController
				outsideNetwork={outsideNetwork}
				districts={districts}
				serviceProviders={serviceProviders}
				providerDescription={requisition?.providerDescription}
				requisitionOutsideNetwork={requisition?.outsideNetwork}
				districtName={requisition?.district?.name}
			/>

			{isFromIsland && (
				<TaskNeedsController
					isAdministrative={true}
					requisition={requisition}
				/>
			)}

			{data.requiresChargeAmount && <TaskPaymentsController />}

			<fieldset className={styles['observation-container']}>
				<ExpandableWidget
					className={styles['observation']}
					heading='h5'
					title={i18n`Administrative Observation`}
				>
					<HFTextInput
						name='administrativeObservation'
						placeholder={i18n`Administrative observation (optional)`}
						multiline={true}
						rows={5}
						noResize
					/>
				</ExpandableWidget>
			</fieldset>
		</>
	)
}
